/*
 * Copyright (c) 2020 Staffino, s.r.o. - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Martin Komara, May 2020
 */

import React from 'react';
import { FlowBlockHeadline as BlockModel } from '@staffino/model';
import { HeadlineBlock as Component } from '@staffino/flow-controls';
import usePropertyTranslation from '../use-property-translation-hook';
import useTemplateRenderer from '../use-template-renderer';

type Props = {
  block: BlockModel;
};

const HeadlineBlock = ({ block }: Props) => {
  const translatedText = usePropertyTranslation(
    block.translations,
    'text',
    block.text,
  );
  const [text] = useTemplateRenderer(translatedText);
  return <Component block={{ ...block, text }} />;
};

export default HeadlineBlock;
